module.exports = __webpack_public_path__ + "img/001.a28377c6.png";